import { FC } from 'react';
import Link from 'next/link';
import SectionTitle from '../section-title/SectionTitle';
import { getAuthorFullName, getBookNoun } from '@/helpers/helpers';
import { ISimilarAuthors } from '@/interfaces/similarAuthors';
import styles from './LibraryAuthors.module.scss';

interface ISimilarAuthorsProps {
  similarAuthors: ISimilarAuthors;
}

const SimilarAuthors: FC<ISimilarAuthorsProps> = ({ similarAuthors }) => {
  return (
    <>
      <SectionTitle name="Похожие авторы" />
      <div className={styles.libraryAuthors}>
        {similarAuthors.map(
          (author) =>
            author.authors_books_count > 0 && (
              <Link prefetch={false} key={author.author_id} className={styles.libraryAuthors__item} href={`/library/author/${author.author_id}`}>
                <span className={styles.libraryAuthors__name}>{getAuthorFullName(author.first_name, author.second_name || '', author.last_name)}</span>
                <span className={styles.libraryAuthors__count}>
                  {author.authors_books_count} {getBookNoun(author.authors_books_count)}
                </span>
              </Link>
            )
        )}
      </div>
    </>
  );
};

export default SimilarAuthors;
